<div *ngIf="hasView" class="alert alert-info mb-0 px-1 px-sm-2">
  <i
    class="fa fa-window-close-o text-danger cursor-pointer float-right position-sticky"
    data-toggle="tooltip"
    title="{{ 'SHARED.CLOSE' | translate }}"
    (click)="onClose()"
  ></i>
  <markdown [data]="pageMarkdown"></markdown>
</div>
